
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"territoryCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TerritoryCountry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iso"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requireZipcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requireStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameTranslated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isShippingCountry"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":150}};
    doc.loc.source = {"body":"fragment territoryCountry on TerritoryCountry {\n  id\n  iso\n  name\n  hasStates\n  requireZipcode\n  requireStates\n  nameTranslated\n  isShippingCountry\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
